import { fetchAuthSession } from "aws-amplify/auth";

export class UserContext {
  constructor(
    public identityId: string,
    public userType: "ADMIN" | "STUDENT" | "INSTITUTION" | "AGENT",
    public userDomain: string | undefined,
    public userEmail: string | undefined,
    public token: string | undefined,
  ) {}

  static async fromSession(): Promise<UserContext> {
    const session = await fetchAuthSession();
    const identityId = session.identityId!;
    const token = session.tokens?.idToken?.toString();
    const idToken = session.tokens?.idToken;
    const userType = idToken?.payload["custom:userType"] as string;
    const userDomain = idToken?.payload["custom:domain"] as string;
    const userEmail = idToken?.payload["email"] as string;

    const ownerType: "ADMIN" | "STUDENT" | "INSTITUTION" | "AGENT" =
      userType === "Admin"
        ? "ADMIN"
        : userType === "Institution"
          ? "INSTITUTION"
          : userType === "Agent"
            ? "AGENT"
            : "STUDENT";

    return new UserContext(identityId, ownerType, userDomain, userEmail, token);
  }

  get isInstitutionOrAgent(): boolean {
    return this.userType === "INSTITUTION" || this.userType === "AGENT";
  }

  get isStudent(): boolean {
    return this.userType === "STUDENT";
  }
}
